bam-back-teaser {
  transform: translateY(100%);
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  height: 0;
  transition: opacity .3s ease-in-out,  transform .3s ease-in-out;
  width: 440px;

  @include touch() {
    width: auto;
    float: right
  }

  &.is-active {
    transform: translateY(0);
    opacity: 1;
    pointer-events: all;
    visibility: visible;
    height: auto;
    margin: .5rem 0 0;
  }

  .back-teaser__content-mobile {
    width: 288px
  }

  .back-teaser__mobile-icon-wrapper {
    button {
      background-color: white !important;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    }
  }

  .back-teaser__icon {
    margin: 0 auto;
    display: block;
    max-height: 80px;

    .bam-image__source {
      height: 100%;
      max-height: 80px;
      width: auto;
      margin: 0 auto
    }
  }

  .back-teaser__headline {
    bal-heading {
      text-align: center;
    }
  }

  .back-teaser__text {
    text-align: center;
  }

  .back-teaser__buttons-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .back-teaser__button {
    width: 100%
  }
}
